interface FileInfo {
    fileName: string;
    fileSize: number;
    fileExtension: string;
  }

export const extractFileExtension = (fileName: string): string => {
  const match = fileName.match(/\.([a-zA-Z0-9]+)$/);
  return match ? match[1].toLowerCase() : 'unknown';
};

const extractFileInfo = (
    body: Document | XMLHttpRequestBodyInit | null,
    options: { fileName?: string } = {}
  ): FileInfo => {
  let file: File | null = null;

  if (body instanceof File) {
    file = body;
  } else if (body instanceof FormData) {
    file = body.get('file') as File
             || body.get('data') as File
             || Array.from(body.values()).find(value => value instanceof File) as File || null;
  }

  const fileName = options.fileName
      || file?.name
      || (body && typeof body === 'object' && 'name' in body ? (body as any).name : null)
      || 'unknown_file';

  const fileSize = file?.size
      || (body && typeof body === 'object' && 'size' in body ? (body as any).size : 0)
      || 0;

  const fileExtension = extractFileExtension(fileName);

  return { fileName, fileSize, fileExtension };
};

export default extractFileInfo;
